module.exports = __webpack_public_path__ + "img/couples-033.8b644ef7.jpg";